"use client";

import { c as _c } from "react/compiler-runtime";
import { DoorOpen, Loader2 } from "lucide-react";
import { useMeetingGuests } from "../model/use-meeting-guests";

/**
 * "Someone is waiting" — the door, from the inside.
 *
 * Rendered on the meeting stage rather than as a toast: a guest standing in the
 * lobby is a state, not an event. A toast that's already faded leaves them
 * outside with nobody aware, which is the exact failure the two-key model was
 * meant to avoid.
 *
 * ANY participant can admit — not only the host. A host who joined late (or
 * never) must not be the single point of failure for a guest they invited.
 *
 * Renders nothing when nobody's knocking, so the stage is unchanged in the
 * common case.
 */
export function GuestKnockNotice(t0) {
  const $ = _c(10);
  const {
    meetingId,
    active
  } = t0;
  const {
    knocking,
    admitGuest,
    isAdmitting
  } = useMeetingGuests(meetingId, active);
  if (knocking.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#c8c5ff]"><DoorOpen className="h-3.5 w-3.5" aria-hidden={true} />Waiting to be let in</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== admitGuest || $[2] !== isAdmitting || $[3] !== knocking) {
    let t3;
    if ($[5] !== admitGuest || $[6] !== isAdmitting) {
      t3 = guest => <div key={guest.id} className="flex items-center gap-2"><span className="min-w-0 flex-1 truncate text-xs text-white/80">{guest.invitedEmail ?? "A guest"}</span><button type="button" onClick={() => void admitGuest({
          inviteId: guest.id
        })} disabled={isAdmitting} className="flex h-7 shrink-0 items-center gap-1 rounded-full bg-white px-3 text-[11px] font-semibold text-[#091E42] transition-all active:scale-[0.97] hover:shadow-[0_2px_10px_rgba(255,255,255,0.35)] focus:outline-hidden focus-visible:ring-2 focus-visible:ring-white/80 disabled:opacity-60">{isAdmitting ? <Loader2 className="h-3 w-3 animate-spin text-[#5651ff]" aria-hidden={true} /> : null}Admit</button></div>;
      $[5] = admitGuest;
      $[6] = isAdmitting;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = knocking.map(t3);
    $[1] = admitGuest;
    $[2] = isAdmitting;
    $[3] = knocking;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <div className="flex flex-col gap-1.5 rounded-xl bg-[#5651ff]/20 p-2.5">{t1}{t2}</div>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}